/**
 * @brief 라우트 변경 시마다 페이지를 상단으로 스크롤하는 기능을 제공하는 함수
 * @details
 * @author hyekyoungKang
 * @date 2024-03-28
 * @version 0.0.1
 */

import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname, state } = useLocation();

  if (state?.fromBack) {
    return; // 뒤로 가기 버튼을 사용한 경우에는 스크롤 위치 변경하지 않습니다.
  }

  // 항상 상단으로 스크롤합니다.
  window.scrollTo(0, 0);

  // useEffect(() => {
  //   // 뒤로 가기 버튼을 사용할 때는 스크롤 위치를 변경하지 않습니다.
  //   if (state?.fromBack) {
  //     return; // 뒤로 가기 버튼을 사용한 경우에는 스크롤 위치 변경하지 않습니다.
  //   }

  //   // 항상 상단으로 스크롤합니다.
  //   window.scrollTo(0, 0);
  // }, []); // pathname과 state가 변경될 때마다 useEffect가 실행됩니다.

  return null;
};

export default ScrollToTop;
